module.exports = __webpack_public_path__ + "img/fixingDataInfo.bf9b793f.png";